import { createGlobalStyle } from 'styled-components'

const CompanyPageStyles = createGlobalStyle`
  .field-url {
    overflow: hidden;
    height: 0px;
    padding: 0;
    transition: all 0.3s;

    &.active {
      padding-bottom: 15px;
      height: 40px;
    }
}
`
export { CompanyPageStyles }
